import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { findSectionModules } from '../../lib/findSectionModules';
import { throwQueryError } from '../../lib/apollo/throwQueryError';
import { useCustomPageVariables } from '../../hooks/useCustomPageVariables';
import { Loading } from '../../components/Loading';
import { LazyModuleSection } from '../../components/LazyModuleSection';
import { NotFoundPage } from '../NotFoundPage';
import { CUSTOM_PAGE_QUERY } from '../HomePage';
import { EditorialPageMeta } from '../EditorialPage/EditorialPageMeta';

export const HomeLandingPage: React.FC = () => {
  const customPageVariables = useCustomPageVariables({ slug: 'home_revised' });

  const { data, loading, error } = useQuery(CUSTOM_PAGE_QUERY, {
    variables: customPageVariables
  });

  const topModules = useMemo(() => findSectionModules(data, 'top'), [data]);
  const headerModules = useMemo(() => findSectionModules(data, 'header'), [data]);
  const bottomModules = useMemo(() => findSectionModules(data, 'bottom'), [data]);

  const modules = useMemo(
    () => [
      ...(topModules?.modules || []),
      ...(headerModules?.modules || []),
      ...(bottomModules?.modules || [])
    ],
    [topModules, headerModules, bottomModules]
  );

  if (loading || !data) return <Loading />;
  if (error) throwQueryError(error);

  if (!data.displayPage) return <NotFoundPage />;

  return (
    <>
      <EditorialPageMeta displayPage={data.displayPage} />
      <LazyModuleSection modules={modules} />
    </>
  );
};
